import React, { Component } from 'react'

import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {
  withRouter
} from 'react-router-dom'

import { Dialog, Button, Intent } from "@blueprintjs/core";

import {load, logar, setPropDataObject} from '../../actions/auth'

class Login extends Component {
  componentWillMount () {
    this.props.load()
  }

  render() {
    let {dataObject, isFetching, error} = this.props

    return (
      <Dialog isOpen={true} onClose={() => {this.close()}} hasBackdrop={false} canEscapeKeyClose={false} canOutsideClickClose={false}
      >
        <div className="pt-dialog-body">
        <div className="pt-non-ideal-state">
          <div className="pt-non-ideal-state-visual pt-non-ideal-state-icon">
            <span className="pt-icon">
              <img src='http://www.qualix.inf.br/wp-content/uploads/2015/09/logo-rconnect.png' alt=''/>
            </span>
          </div>
        </div>
          <div className="pt-card .modifier">
            <div className="pt-form-group">
              <label className="pt-label">
                Usuário
              </label>
              <div className="pt-form-content">
                <div className="pt-input-group">
                  <input type="text" className="pt-input pt-round" placeholder="Informe seu usuário..."
                    value={dataObject.login}
                    onChange={({target}) => {this.onChange({login: target.value})}}/>
                  <span className="pt-icon pt-icon-user"></span>
                </div>
              </div>
            </div>
            <div className="pt-form-group">
              <label className="pt-label">
                Senha
              </label>
              <div className="pt-form-content">
                <div className="pt-input-group">
                  <input type="password" className="pt-input pt-round" placeholder="Informe sua senha..."
                    value={dataObject.password}
                    onChange={({target}) => {this.onChange({password: target.value})}}/>
                  <span className="pt-icon pt-icon-lock"></span>
                </div>
              </div>
            </div>
            <div className="pt-callout pt-intent-danger" style={{display: error.message ? 'inherit' : 'none'}}>
              <h5>{error.response_code}</h5>
              {error.message}
            </div>
          </div>
        </div>
        <div className="pt-dialog-footer">
            <div className="pt-dialog-footer-actions">
                <Button
                    intent={Intent.PRIMARY}
                    loading={isFetching}
                    onClick={() => {this.logar()}}
                    text="Entrar"
                />
            </div>
        </div>
      </Dialog>
    );
  }

  logar () {
    this.props.logar()
  }

  onChange (data) {
    this.props.setPropDataObject(data)
  }
}

function mapStateToProps (state) {
  let {dataObject, isFetching, error} = state.auth

  return {
    dataObject,
    isFetching,
    error
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({load, setPropDataObject, logar}, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login))


// WEBPACK FOOTER //
// ./src/scenes/login/Login.js